(function ($, konto) {
    var Ispis = function (unique, options) {
        var that = this;
        konto.KontoBase.call(that, unique, options);
        
        that.id = "ispis-" + unique;
        that.form = $("#" + that.id);
        that._setNaslovIzvjestaja = true;

        $.extend(that, options);
                
        /**
         * Za kreiranje ključa koristi se baseActionName zbog AJAX navigacije.
         * U ovom trenutku se metodi action dodaje Ajax sufiks prilikom ajax poziva, kao npr.
         * pregled -> pregledAjax
         * 
         */
        that.cookieKey = that.cachePrefix + "-" + that.controllerName + "-" + that.baseActionName;
        that.cookieKeyOld =  that.cachePrefixOld + "-" + that.controllerName + "-" + that.baseActionName;
        that.cookieKeySuffix = "";
        that.makniParam = [];
        
        that.beforeLoaded(function () {
        	that._overrideEnterBehaviour();
        });
                
        //dodano zbog ajaxAsync = true, jer se onda trpa u queu i treba ga startati.
		$("body").on("ispisloaded." + unique, function() {

            //ajmo popuniti comboboxeve
            if (that.comboDataObject) {
				that.sel('.combobox-group').each(function () {
	                that.popuniComboboxeve(that.comboDataObject, this);
	            });            			
            }			
			
			if (that._ajaxAsync === true)
				that._ajaxQueue.start();
		});
        that.loaded(function () {
			$("input[name=fld-ispisUPozadini]").prop("checked", false);        	
            that.sel(".btn-submit").click(function () {
            	that.beforeSubmit();  
            	if(that.executeSubmit){          	        	 	           		
					$("input[name=fld-ispisUPozadini]").prop("checked", false);            		
			        function checkPendingRequest() { 
			            if ($.active > 0) { 
			                setTimeout(checkPendingRequest, 500);
			            }else{			            	
			                var data = $(that.form).serialize()+ '&nazivIzvjestaja=sasa';
			                var dlg = null;
			                $.fileDownload(that.form.prop("action") + "?fileDownload", {
			                    httpMethod: "POST",
			                    data: data,
			                    prepareCallback: function (url) {
			                        dlg = konto.dialogs.modal({
			                            title: "Generiranje izvještaja",
			                            content: "Molimo pričekajte."
			                        });
			                    },
			                    successCallback: function () {
			                        if (dlg)
			                            dlg.close();
			                    },
			                    failCallback: function (responseHtml, url) {
			                    	KUtils.busy(false);
			                        if (dlg)
			                            dlg.close();
			                    
			                        // JSON greške bi se mogle naći u HTML-u.
			                        var ispisan = false;
			                        var html = $(responseHtml);   
			                        try {                      
			                            var json = $.parseJSON(html.text());
			                            if (json && json.error) {
											ispisan = true;
			                                konto.dialogs.greska({
			                                    content: json.error
			                                });
			                            }
			                        }
			                        catch (e) { }
			                        
			                        if (ispisan === false) {
			                            if (responseHtml == '')
			                                responseHtml = "Nema podataka za zadane parametre. Provjerite i promijenite unesene parametre izvještaja.";
                                        konto.dialogs.greska({
			                                content: responseHtml
			                            });
			                        }
			                    }
			                }); 
			                //kraj file downloada
			            }
			        };			
                    checkPendingRequest();
				};
            });

            that.sel(".btn-pregledUPozadini").click(function () { 
                that.beforeSubmit(); 
            	btnUPozadini = this;           	
				$(function () {		
					$("input[name=fld-ispisUPozadini]").prop("checked", true);	
					that.setNaslovIzvjestaja();	
                    $.ajax({
						url: that.form.prop("action"),
                        method: "POST",
                        data: $(that.form).serialize()
                    })                    	
	                .done(function (data, textStatus, jqXHR) {             	
                        var dialog = $(btnUPozadini).closest("div.kontomodal").data("kendoKontoModal");
                        if (dialog)
                            dialog.close();
                        
                        if (notifikacijaObjekt){ 
                            clearTimeout(notifikacijaObjekt);
                            konto.Notifikacija.provjeriNotifikacijePeriodicki();
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        // dialog se diže sam
                    });   
                    //$("input[name=fld-ispisUPozadini]").prop("checked", false);
            	});
            });
            

            that.sel(".btn-email").click(function () {
            	$(function () {
						$("input[name=fld-ispisUPozadini]").prop("checked", false);            		
				        function checkPendingRequest() { 
				            if ($.active > 0){ 
				                setTimeout(checkPendingRequest, 500);
				            }else
				            {
				                $("input[name=fld-ispisEMail]").prop("checked", true);            	
				                var eMail = that.sel(".eMail").val();
				                var data = $(that.form).serialize();                
				                var action = that.form.prop("action");
				
				                $.dialog({
				                    title: "Slanje izvještaja na e-mail",
				                    content: "Poslati izvještaj na e-mail adresu <strong>" + eMail + "</strong>?",
				                    buttons: {
				                        "Da": {
				                            isPrimary: true,
				                            click: function () {
				                                this.close();
				
				                               var req = $.ajax({
				                                    url: action,
				                                    method: "post",
				                                    data: data
				                                });
				                                setTimeout(function(){
				                                    req.abort();
				                                }, 2000)
				                                 
				                                konto.dialogs.modal({
				                                    title: "Generiranje izvještaja",
				                                    content: "Izvještaj će po završetku generiranja biti poslan na e-mail adresu <strong>" + eMail + "</strong>. Možete zatvoriti ovaj prozor. Nakon što dobijete izvještaj na mail možete nastaviti sa radom u web aplikaciji. "
				                                });
				                            }
				                            },
				                            "Ne": function () {
				                            this.close();
				                        }
				                    }
				                });
								$("input[name=fld-ispisEMail]").prop("checked", false);  	
				            }
				        };			
				        checkPendingRequest();
				});			         				
				              
            }); //btn email click

            that.sel(".btn-ponistiVrijednosti").click(function () {
				$("input[name=fld-ispisUPozadini]").prop("checked", false);            	
                that.ponistiVrijednosti();
                that.afterPonisti();
            });
            
            if (that.grafovi && that.grafovi.enabled !== false) {
                that.sel(".btn-group-graf").removeClass("hide");
                that.sel(".btn-graf").click(function () {
					$("input[name=fld-ispisUPozadini]").prop("checked", false);                	
                    that.toggleButtonsDisabled(true);
                    $.ajax({
                        url: that.grafovi.url,
                        type: "POST",
                        data: that.form.serialize(),
                        dataType: "html"
                    })
                        .done(function (data, textStatus, jqXHR) {
                            var graphWindow = $("<div></div>");
                            $("body").append(graphWindow);
                            var d = graphWindow.kendoKontoModal({
                                title: "Grafički prikaz",
                                content: data,
                                large: false,
                                width: "90%",
                                shown: function () {
                                    $(window).trigger("resize");
                                }
                            }).data("kendoKontoModal");
                            d.show();
                        })
                        .always(function () {
                            that.toggleButtonsDisabled(false);
                        });
                });
            }
        });
        
        $("body").on("ispisloaded." + that.unique, function () {
            $(window).on("beforeunload." + that.unique + " beforepageunload." + that.unique, that.zapamtiParametreIspisa.bind(that));
            that.restoreParametreIspisa();
        
            $("body").trigger("ispis." + that.unique);
        });     
    };
    
    konto.Ispis = Ispis;
    
    Ispis.prototype = Object.create(konto.KontoBase.prototype);
    Ispis.prototype.constructor = Ispis;
    
    $.extend(Ispis.prototype, {
    	executeSubmit: true,
        setNaslovIzvjestaja: function(){
            if (this._setNaslovIzvjestaja === true){
                var pomNaslov = $('span.headerTitle').last().html();
                if (pomNaslov) {
                    $("input[name=fld-naslovIzvjestaja]").val(pomNaslov);
                }
                else {
                    pomNaslov = $('span#page-title.page-header-text').last().html();        
                    if (pomNaslov) {
                        $("input[name=fld-naslovIzvjestaja]").val(pomNaslov);
                    }           
                }   
            }   
        },   
        /**
         * Popunjava comboboxeve u formi 
         */
        popuniComboboxeve: function (comboDataObjects, element) {
            var that = this;
            var cmbName = $(element).data('element-name');
            	cmbDataModel = cmbName.split('cmb')[1];
            
            if (!isset(cmbName)) {
            	cs ('Ne postoji naziv combobox elementa "element-name" !');
            	return;
            }
            
            if (isset(that[cmbName])) {
	        	for (model in comboDataObjects) 
	        		if (cmbDataModel == model) {
	        			
		        		var data = comboDataObjects[model];
		    			if (data.length > 0) {
	    					var cmb = that[cmbName];    				
			        			cmb.setDataSource(data);
			        			cmb.dataSource.read();
			        			cmb.refresh();
			        	}
					}
			} else {
				cs ('ne postoji combobox: '+cmbName);
			}
        	
        },
        ponistiVrijednosti: function () {
            var that = this;
            var selector = "[name*=\"fld" + "-\"]";
            var controls = that.sel(selector);
            var inputs = {};
            $.each(controls, function (index, el) {
                var name = el.name.toLowerCase();
                inputs[name] = $(el);
            });
            
            $.each(inputs, function (key, value) {
                if (value.hasClass("ne-ponisti")) {
                    return;
                }
                // Value od radio buttona ne brišem.
                if (value.is("input") && value.attr("type") == "radio") 
                    return;
            
                var kontoIspis = value.closest(".konto-ispis-input");
                if (kontoIspis.length > 0) {
                    var ispis = kontoIspis.data("kendoIspis");
                    ispis.clear();
                    return;
                }
                
                if (value.hasClass("konto-input-date")) {
                    value.data("kendoDatePicker").value(null);
                }
                else if (value.hasClass("konto-input-datetime")) {
                    value.data("kendoDateTimePicker").value(null);
                }
                else if (value.hasClass("konto-input-datetime-ss")) {
                    value.data("kendoDateTimePicker").value(null);
                }
                else if (value.hasClass("konto-input-year")) {
                    value.data("kendoDatePicker").value(null);
                }
                else if (value.hasClass("konto-dropdownlist")) {
                    value.data("kendoDropDownList").value(null);
                }
                else if (value.attr("type") == "checkbox") {
                    value.attr("checked", null);
                }
                else if (value.data("kendoMultiSelect")) {
                    value.data("kendoMultiSelect").value([]);
                }
                else {
                    value.data("value", null);
                    value.val("");
                }
                // Da li ovdje treba blur?
                // value.blur();
            });
            
            var tabs = that.sel("a.restored-value");
            tabs.each(function (index, el) {
                el = $(el);
                var text = el.html();
                text = text.substring(0, text.length - 2);
                el.html(text);
                
                el.removeClass("restored-value");
            });
        }, 
        afterPonisti: function(){
        },    
        paramStringToObject: function (s) {
            if (typeof s === "undefined" || s == "") {
                return {};
            }
            else {
                var arr = s.split("&");
                return this.paramArrayToObject(arr);
            }
        },      
        paramArrayToObject: function (arr) {
            var obj = {};
            for (var i = 0; i < arr.length; ++i) {
                var el = arr[i].split("=");
                var key = el[0];
                var value = el[1];
                // Da li je array?
                var isArray = key.slice(-2) === "[]";
                if (isArray) {
                    if (!$.isArray(obj[key])) {
                        obj[key] = [];
                    }
                    obj[key].push(value);
                }
                else {
                    obj[key] = value;   
                }
            }
            return obj;
        },      
        paramObjectToArray: function (obj) {
            var arr = [];
            var length = 0;
            $.each(obj, function (key, value) {
                var el = key + "=" + value;
                // Provjeravam veličinu cookieja.
                if (length + el.length < 4000) {
                    arr.push(el);
                    length += el.length;
                }
            });
            return arr;
        },
        /**
         * Funkcija merge-a parametre cookie1 i cookie2. cookie1 je prioritetan
         * */
        mergeParameters: function (obj1, obj2) {
            /**
            var elements1 = cookie1.split("&");
            var elements2 = cookie2.split("&");
            if (!cookie2)
                elements2 = [];
            
            var obj1 = that.paramArrayToObject(elements1);
            var obj2 = that.paramArrayToObject(elements2);
            */
            
            $.each(obj2, function (key, value) {
                if (typeof obj1[key] === "undefined" && !$.isArray(value) /* array ne mergeam */) {
                    var el = $("[name=\"" + key + "\"]");
                    // Checkboxe ne mergeam (ako postoje)
                    if (el.length > 0 && el.is("input") && el.attr("type") == "checkbox")
                        return;
                    
                    obj1[key] = value;
                }
            });
            
            return obj1;
        },
                
        /**
         * Funkcija koja miče parametre za one elemente koji se ne spremaju u storage. Npr. filename, tip izvještaja, verzija
         * izvještaja, datum izvještaja i slično.
         */
        removeNoStorageParameters: function (obj) {
            var that = this;
            var res = {};
            $.each(obj, function (key, value) {
                var el = that.sel("[name=\"" + key + "\"]");
                if (!el.hasClass("no-storage")) {
                    res[key] = value;
                }
            });
            return res;
        },
        getCacheKey: function(){
            return this.cookieKey + this.cookieKeySuffix;    
        },
        getCacheKeyOld: function(){
            return this.cookieKeyOld + this.cookieKeySuffix;    
        },        
        zapamtiParametreIspisa: function () {
            var oldCache = simpleStorage.get(this.getCacheKey());
            if (typeof oldCache === "undefined") {
                oldCache = simpleStorage.get(this.getCacheKeyOld());
                if (typeof oldCache === "undefined"){	
                    oldCache = {}; 				
                }
                else{
                    simpleStorage.set(this.getCacheKey(), oldCache);
                }	
            }
            var cache = $(this.form).serialize();
            var cacheLiteral = this.paramStringToObject(cache);
            cacheLiteral = this.mergeParameters(cacheLiteral, oldCache);
            cacheLiteral = this.removeNoStorageParameters(cacheLiteral);
            try {
                simpleStorage.set(this.getCacheKey(), cacheLiteral);
            } catch (e) { console.log(e); }
        },
        removeParametreIspisa: function (parametri) {
            var oldCache = simpleStorage.get(this.getCacheKey());
            if (typeof oldCache === "undefined"){
                oldCache = simpleStorage.get(this.getCacheKeyOld());
            }            
            if (oldCache){       
                $.each(parametri, function (key, value) {
                    if (oldCache[value] != undefined){
						delete oldCache[value]; 
					}                     
                });
                try {
                    simpleStorage.set(this.getCacheKey(), oldCache);
                } catch (e) { console.log(e); }
            }
        },        
        restoreParametreIspisa: function () { 
            var that = this;
            var cache = simpleStorage.get(this.getCacheKey());
            if (typeof cache === "undefined"){
                cache = simpleStorage.get(this.getCacheKeyOld());
                if (typeof cache === "undefined"){	
                    return; 				
                }
            }            
            //cs (cache);

            $.each(cache, function (key, value) {
                if (value == "")
                    return;
                    
                // Može npr. biti i array
                if (typeof value === "string") {
                    value = value.replace(/\+/g, "%20");
                    value = decodeURIComponent(value);
                }
                
                var selector = "[name=\"" + key + "\"]";
                var input = that.sel(selector);
                var postavljeno = false;
                
                if (input.length == 1) {
                    var kontoIspis = input.closest(".konto-ispis-input");
                    if (kontoIspis.length > 0) {
                        var el = kontoIspis.data("kendoIspis");
                        el.setFromCache(value);
                    }
                    else if (input.hasClass("konto-input-date")) {
                        var d = KUtils.parseDate(value);    
                        input.data("kendoDatePicker").value(d);
                    }
                    else if (input.hasClass("konto-input-datetime")) {
                        var dt = KUtils.parseDateTime(value);
                        input.data("kendoDateTimePicker").value(dt);
                    }
                    else if (input.hasClass("konto-input-datetime-ss")) {
                        var dt = KUtils.parseDateTime(value);
                        input.data("kendoDateTimePicker").value(dt);
                    }
                    else if (input.hasClass("konto-dropdownlist")) {
                        input.data("kendoDropDownList").value(value);
                    }
                    else if (input.attr("type") == "checkbox") {
                        input.attr("checked", value == "on" ? "checked" : null);
                    }
                    else if (input.data("kendoMultiSelect")) {
                        input.data("kendoMultiSelect").value(value);
                    }
                    else {
                        input.data("value", null);
                        input.val(value);
                        input.blur();
                    }
					if (input.attr("type") === "checkbox")
						postavljeno = value == "on" && (typeof input.data("defaultValue") !== "on");						
					else                 
                    	postavljeno = (typeof input.data("defaultValue") === "undefined") || (input.data("defaultValue") != value);
                }       
                else if (input.length > 1) {
                    // Radio
                    var first = input[0];
                    if (first.type == "radio") {
                        var button = input.filter("[value=" + value + "]");
                        if (button.length) {
                            button.prop("checked", true);
                            postavljeno = !button.hasClass("default-radio");
                        }
                    }
                    
                }
                
                if (postavljeno) {
                    // Tražimo tab da ga označimo kao da je nešto postavljeno u njemu.
                    var tabPane = input.closest(".tab-pane");
                    var tabId = tabPane.attr("id");
                    var tabContent = tabPane.closest(".tab-content");
                    var parent = tabContent.parent();
                    var kartica = parent.find("a[href=\"#" + tabId + "\"]");
                    if (!kartica.hasClass("restored-value")) {
                        kartica.addClass("restored-value");
                        kartica.html(kartica.html() + " *");
                    }
                }
            });
        },
        toggleButtonsDisabled: function (disabled) {
            this.sel(".ispis-footer-buttons button").prop("disabled", disabled);
        },
        podesiFormuPremaFormParam: function(formParam, isModalForm){
			if(isModalForm){
				$('.headerTitle').addClass('Caption'); 	
			}
			else{
				$('.page-header-text').addClass('Caption'); 	
			}			
			
            var that = this;
            $.each(formParam, function (key, val) {
                $obj = $('.'+val.FName);
                if ($obj.length != 0){
                    if ($obj.hasClass('radio-list-group')){  
                        $obj.radioListGroupCreate(val);                      
                    }else if ($obj.hasClass('formParam-combobox-group')){ 
                        $obj.comboboxGroupCreate(val);  
                    }else if ($obj.hasClass('list-group')){ 
                        $obj.checkListGroupCreate(val);  
                    }else if ($obj.hasClass('list-group-string')){
						$obj.checkListGroupStringCreate(val);	
					}else if ( $obj.hasClass('cb-item') || $obj.hasClass('konto-checkbox-extended') ){ 
                        $obj.setCheckboxFPProperty(val);
                    }else if ($obj.hasClass("konto-ispis-input")){
                        var rez = $obj.setKontoIspisInputFPProperty(val);
                        if (rez.length > 0)
                            that.makniParam.push(rez); // za sad samo value 
                    }else{
                        //Visible
                        if (val.FIsSetVisible){
                            $obj.setVisible(val.FVisible);        
                        };
                        
                        //Enabled
                        if (val.FIsSetEnabled){                                
                            if ($obj.hasClass('list-group-item') && !val.FEnabled){
                                $obj.addClass('disabled');    
                            }else{
                                $obj.setEnabled(val.FEnabled);    
                            }         
                        }; 
                        
                        //DisplayLabel
                        if (val.FIsSetDisplayText){
                            $obj.text(val.FDisplayText);    
                        }  
                                                
                        //Value
                        if (val.FIsSetValue){
							//ako negdje nađe više, npr na date objektu nađe span i input onda uzimamo samo input
							if ($obj.length > 1){
								$obj = $obj.find(':input');
							}							
                            if ($obj.hasClass("konto-input-date") || ($obj.hasClass("int-value"))) {
                                $obj.val(val.FValue);
                            }else{
                                $obj.kval(val.FValue);    
                            }
                            that.makniParam.push($obj.attr('name'));      
                        }                       
                        
                        //Checked
                        if (val.FIsSetChecked){
                            $obj.setKontoChecked(val.FChecked);      
                        } 
                    }  
                }else if(val.FName == 'SetFocus'){
					if (val.FValue){
						that._setFocus = that.sel('.' + val.FValue);	
					}                     	  
                }
            });
            that.removeParametreIspisa(that.makniParam); //na kraju sve postaljene mičemo iz cachea
        },
        beforeSubmit: function(){
        	var that = this;
        	var countObj = 0;
        	var errorMsg = '';
        	        		    
    		var inputObjs = $(".konto-ispis-input");    		
			for(i=0; i<inputObjs.length; i++){
				var el = $(inputObjs[i]);
				var onlyEl = el.data("allow-only-one-element"); 		
				if(onlyEl){
    				var dataName = el.data("name");
    				var dataValue = $("[name='" + dataName +"']").val();   									
					if(dataValue != ""){
						const obj = JSON.parse(dataValue);							
						if(obj.length > 1){
							countObj++;
							var locMsg = el.closest(".form-group").find(".control-label").text();
							errorMsg = errorMsg + locMsg + ', ';
						}							
					}
				}				
			} 
			
			if(countObj > 0){	
				that.executeSubmit = false;
				konto.dialogs.greska({
	        		content: errorMsg.substring(0, errorMsg.length - 2) + " - dozvoljen je unos samo jedne vrijednosti!"
	    		});						
			}
			else{
				that.executeSubmit = true;
			}
        },        
    });
} (jQuery, window.konto = window.konto || {}));
